import React from 'react';
import PropTypes from 'prop-types';
import css from './CompanyList.module.scss';
import cn from 'classnames';

const CompanyListTab = ({
    businessArea,
    name, 
    onClick = () => {},
    isActive=false,
    isGrayedOut = false
}) => (
    <li className={css.tab} id={businessArea}>
        <button 
            className={cn(css['tab-button'],{
                [css['active']] : isActive,
                [css['grayed-out']] : isGrayedOut
            })}
            disabled={isActive}
            onClick={onClick}
        >{name}</button>
    </li>
);

CompanyListTab.propTypes = ({
    businessArea: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    isActive: PropTypes.bool,
    isGrayedOut: PropTypes.bool
});

export default CompanyListTab;



// WEBPACK FOOTER //
// ./src/components/CompanyList/CompanyListTab.jsx